"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadProfile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const file_saver_1 = require("file-saver");
const Api = __importStar(require("@src/api"));
const downloadProfile = async (accountUuid, intl, setLoading, applicantProfileData) => {
    try {
        if (setLoading) {
            setLoading(true);
        }
        let applicantProfile = applicantProfileData;
        if (!applicantProfile) {
            applicantProfile = await Api.Profile.getApplicantProfile(accountUuid);
        }
        const { pdf } = await Promise.resolve().then(() => __importStar(require('@react-pdf/renderer')));
        const { ApplicantProfilePDF } = await Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/resume/PDF/ApplicantProfilePDF')));
        const applicantProfilePDF = await pdf((0, jsx_runtime_1.jsx)(ApplicantProfilePDF, { applicantProfile: applicantProfile })).toBlob();
        const fileName = `${applicantProfile === null || applicantProfile === void 0 ? void 0 : applicantProfile.first_name}_${applicantProfile === null || applicantProfile === void 0 ? void 0 : applicantProfile.last_name}_${accountUuid}.pdf`;
        (0, file_saver_1.saveAs)(applicantProfilePDF, fileName);
    }
    catch (err) {
        antd_1.notification.error({
            message: intl.formatMessage({
                id: 'global.notification_variants.error',
            }),
            description: intl.formatMessage({
                id: 'global.notification_variants.something_went_wrong',
            }),
        });
        // eslint-disable-next-line no-console
        console.error(err);
    }
    finally {
        if (setLoading) {
            setLoading(false);
        }
    }
};
exports.downloadProfile = downloadProfile;
